import {
    baseStates,
    baseMutations,
    baseActions,
    baseGetters,
} from '@/stores/base';

export const companyOrder = {

    namespaced: true,

    state:
    {
        ...baseStates,

        url: '/orders',

        branches: [],
        branchesLoading: false,

        vehicleTypes: [],
        vehicleTypesLoading: false,
        vehicleTypeLoading: false,

        partCategories: [],
        partCategoryLoading: false,
        partCategoriesLoading: false,

        measurements: [],
        measurementLoading: false,
        measurementsLoading: false,

        paymentMethods: [],
        paymentMethodLoading: false,
        paymentMethodsLoading: false,
        
        mechanics: [],
        mechanicLoading: false,
        mechanicsLoading: false,
    },

    mutations:
    {
        ...baseMutations,
    },

    actions:
    {
        ...baseActions,
    },

    getters:
    {
        ...baseGetters,

        branches: state => state.branches,

        vehicleTypes: state => state.vehicleTypes,

        partCategories: state => state.partCategories,

        measurements: state => state.measurements,

        mechanics: state => state.mechanics,

        paymentMethods: state => state.paymentMethods,
    },
};
